import React from 'react';
import {connect} from 'react-redux'
import {Route, Switch, withRouter} from 'react-router-dom'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import {clearAlert, clearState} from 'Skelet/src/modules/fetch.action.js'
import AlertBar from 'Skelet/src/components/AlertBar.js'
import Start from './Start.js'
import AItraining from './AItraining.js'
import SEOgoogle from './SEOgoogle.js'
import SEAds from './SEAds.js'
import SocialAgency from './SocialAgency.js'
import Webdesign from './Webdesign.js'
import Websites from './Websites.js'
import WebsiteFixer from './WebsiteFixer.js'
import Marketing from './Marketing.js'
import Advice from './Advice.js'
import GrowthAutomation from './GrowthAutomation.js';
import Fitness from './Fitness.js'
import Reviews from './Reviews.js'
import CaseStudyDieetClub from './CaseStudy-DieetClub.js'
import Contact from './Contact.js';
import Privacy from './Privacy.js'
import redir_fb from './redir_fb.js'
import redir_li from './redir_li.js'
import redir_bs from './redir_bs.js'
import redir_gmb from './redir_gmb.js'
import PageNotFound from 'Skelet/src/components/PageNotFound.js'
import StartRoute from './route-containers/StartRoute.js'


class App extends React.Component {

  render() {
    return (
      <div id="main">
        <Switch>
          <StartRoute exact path="/" component={Start} />
          <StartRoute exact path="/ai-training" component={AItraining} />
          <StartRoute exact path="/google-seo" component={SEOgoogle} />
          <StartRoute exact path="/advertenties-bureau" component={SEAds} />
          <StartRoute exact path="/social-media-bureau" component={SocialAgency} />
          <StartRoute exact path="/webdesign" component={Webdesign} />
          <StartRoute exact path="/websites" component={Websites} />
          <StartRoute exact path="/website-fixer" component={WebsiteFixer} />
          <StartRoute exact path="/marketing" component={Marketing} />
          <StartRoute exact path="/online-marketing-advies" component={Advice} />
          <StartRoute exact path="/groei-en-automatisering" component={GrowthAutomation} />

          <StartRoute exact path="/fitness" component={Fitness} />

          <StartRoute exact path="/case-study-dieet-club" component={CaseStudyDieetClub} />

          <StartRoute exact path="/reviews" component={Reviews} />

          <StartRoute exact path="/contact" component={Contact} />

          <StartRoute exact path="/privacy" component={Privacy} />

          <Route exact path="/facebook" component={redir_fb} />
          <Route exact path="/linkedin" component={redir_li} />
          <Route exact path="/bluesky" component={redir_bs} />
          <Route exact path="/review" component={redir_gmb} />
          <Route exact path="/nieuwe-review" component={redir_gmb} />

          <Route path="*" component={PageNotFound} />
        </Switch>
        <AlertBar alert={this.props.alert} clearAlert={this.props.clearAlert} />
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    state_router: state.router, // needed for redirect after login
    session_token: session_token,
    redirectUrl: state.apiData.redirectUrl,
    alert: state.apiData.alert,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    clearAlert,
    clearState,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/_app.js